/**
 * YubinBango - 郵便番号から住所自動入力
 * yubinbango-core（CDN）のグローバル変数を利用
 */
export function yubinbango() {
  const postal1 = document.querySelector(".js-postal1");
  const postal2 = document.querySelector(".js-postal2");
  const address1 = document.querySelector(".js-address1");

  if (!postal1 || !postal2 || !address1) return;

  function fetchAddress() {
    const code = postal1.value + postal2.value;
    if (code.length === 7 && window.YubinBango) {
      new window.YubinBango.Core(code, (addr) => {
        if (addr.region) {
          address1.value =
            addr.region + addr.locality + (addr.street || "");
        }
      });
    }
  }

  postal1.addEventListener("input", fetchAddress);
  postal2.addEventListener("input", fetchAddress);
}
